import { createEvent } from 'effector';
import { Order } from './entities';

export const logOutUser = createEvent();

export const openRetryPayment = createEvent<{ order: Order }>();

export const closeRetryPayment = createEvent();

// export const getOrdersList = createEvent<{
//   limit: number;
//   offset: number;
// }>();
